import { Phone, Mail, MapPin, Star, Instagram, Youtube } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const googleReviewLink = 'https://share.google/gYAFU6Se5VYqhVkLq';

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-orange-400 to-orange-400 bg-clip-text text-transparent mb-4">
              A to Z Home Solutions
            </h3>
            <p className="text-gray-400 mb-4">
              Your trusted partner for complete home solutions, from vision to reality.
            </p>
            <button
              onClick={() => window.open(googleReviewLink, '_blank')}
              className="flex items-center gap-2 text-orange-400 hover:text-orange-300 transition-colors duration-200 mb-4"
            >
              <Star size={18} className="fill-orange-400" />
              <span>Rate us on Google</span>
            </button>
            <div className="flex gap-4">
              <button
                onClick={() => window.open(mockData.company.social.instagram, '_blank')}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </button>
              <button
                onClick={() => window.open(mockData.company.social.youtube, '_blank')}
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-200"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Founders', 'Services', 'Projects', 'Testimonials', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-gray-400 hover:text-orange-400 transition-colors duration-200"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              {mockData.services.map((service) => (
                <li key={service.id}>
                  <span className="text-gray-400">{service.title}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="text-orange-400 flex-shrink-0 mt-1" size={18} />
                <div className="text-gray-400">
                  <div>{mockData.company.phone}</div>
                  <div>{mockData.company.phone2}</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="text-orange-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-gray-400 break-all">{mockData.company.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="text-orange-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-gray-400">{mockData.company.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} A to Z Home Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};